import { render } from "./GapiSettingView.vue?vue&type=template&id=70ea4f48"
import script from "./GapiSettingView.vue?vue&type=script&lang=js"
export * from "./GapiSettingView.vue?vue&type=script&lang=js"

import "./GapiSettingView.vue?vue&type=style&index=0&id=70ea4f48&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/GapiSettingView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70ea4f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70ea4f48', __exports__)) {
    api.reload('70ea4f48', __exports__)
  }
  
  module.hot.accept("./GapiSettingView.vue?vue&type=template&id=70ea4f48", () => {
    api.rerender('70ea4f48', render)
  })

}


export default __exports__